<template>
  <div>
    <sidemenu hidden-print/>
    <v-content>
      <v-container fluid fill-height>
        <router-view/>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import systemMixin from '@/mixins/systemMixin';

export default {
  mixins: [systemMixin],
  
  components: {
    Sidemenu: () => import('./sidemenu/Main.vue'),
    // Notifications: () => import('@/components/desktop/notifications/Main.vue'),
  },
  
  mounted() {
    // Update CSS variables when component mounts
    this.updateCSSVariables();
  }
};
</script>
